export const DataHook = {
    Title: 'title',
    Subtitle: 'subtitle',
    Badge: 'badge',
    PrimaryAction: 'primary-action',
    SecondaryAction: 'secondary-action',
    HoverContent: 'hover-content',
    HoverComponent: 'hover-component',
    SettingsMenu: 'settings-menu',
    Container: 'container',
    footer: 'footer',
    dragHandle: 'drag-handle',
    footerImage: 'footer-image',
    suffix: 'suffix',
};
export const SIZES = {
    small: 'small',
    medium: 'medium',
};
//# sourceMappingURL=CardGalleryItem.constants.js.map